import { Component, OnInit, Input } from '@angular/core';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-call-business-user',
  templateUrl: './call-business-user.component.html',
  styleUrls: [
    './call-business-user.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallBusinessUserComponent implements OnInit {
  @Input() user: BusinessUser;

  constructor(
    public mg: MgService,
  ) { }

  ngOnInit(): void {
  }

}
